'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationFlightAssignmentController = function ConfigurationFlightAssignmentController($scope, dataRetrieverService, configurationFlightAssignmentService, $log, configurationService) {
  var CONFLICT_ERROR_CODE = 409;
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', 'configuration-flight-assignment-mode').setCustomSearchCriteriaRules([]);
  function showError(error) {
    var message = error.status === CONFLICT_ERROR_CODE ? 'Duplicate record exists' : error.data && error.data.message || error.statusText || error.message;
    $log.error('ConfigurationFlightAssignmentController: showError - ' + message);
    toastr.error(message);
  }
  function onSuccessSaving() {
    $scope.$broadcast('configuration-assignment-grid:saveSuccess');
    toastr.success('Data was saved successfully');
    $scope.$broadcast('grid:dataChanged');
  }
  function onSuccessDeletion() {
    $scope.$broadcast('grid:dataChanged');
  }
  function validate(rows) {
    _.each(rows, function (row) {
      if (row.hasOwnProperty('carrier') === false || _.isEmpty(row.carrier)) {
        throw new Error('\'Airline Code\' can not be empty.');
      }
      if (row.hasOwnProperty('number') === false || !row.number) {
        throw new Error('\'Flight number\' can not be empty.');
      }
      if (row.hasOwnProperty('origin') === false || _.isEmpty(row.origin)) {
        throw new Error('\'Origin\' can not be empty.');
      }
      if (row.hasOwnProperty('destination') === false || _.isEmpty(row.destination)) {
        throw new Error('\'Destination\' can not be empty.');
      }
      if (row.hasOwnProperty('entityAssignment') === false || _.isEmpty(row.entityAssignment)) {
        throw new Error('\'Entity Assignment\' can not be empty.');
      }
      if (!configurationService.isNonCodeShareMarket(row)) {
        throw new Error('You can\'t save Code Share Market.');
      }
    });
  }
  $scope.saveChanges = function (event, rows) {
    try {
      validate(rows);
      if (rowsToBeRemoved.length > 0) {
        configurationFlightAssignmentService.remove(rowsToBeRemoved).then(onSuccessDeletion, showError);
        rowsToBeRemoved = [];
      }
      configurationFlightAssignmentService.save(rows).then(onSuccessSaving, showError);
    } catch (e) {
      $log.error('ConfigurationFlightAssignmentService: saveChanges - ' + e);
      toastr.error(e);
    }
  };
  var rowsToBeRemoved = [];
  $scope.removeFlightAssignements = function (event, rowsToRemove) {
    _.forEach(rowsToRemove, function (row) {
      delete row.isNewlyAdded;
      rowsToBeRemoved.push(row);
    });
  };
};
ConfigurationFlightAssignmentController.$inject = ['$scope', 'DataRetrieverService', 'ConfigurationFlightAssignmentService', '$log', 'ConfigurationService'];
module.exports = ConfigurationFlightAssignmentController;